
function defaultKeyFunc(item) {
    return item[0];
}

function defaultLabelFunc(item) {
    return item[1];
}


function LabeledArray(data, keyFunc, labelFunc) {
    var key, label;

    keyFunc = keyFunc || defaultKeyFunc;
    labelFunc = labelFunc || defaultLabelFunc;

    this.index = {};
    this.labels = [];

    for (var i = 0; i < data.length; i++) {

        key = keyFunc(data[i]);
        label = labelFunc(data[i]);

        if (Array.isArray(label)) {
            label = new LabeledArray(label, keyFunc, labelFunc);
        }

        this.push(key);
        this.labels.push(label);
        this[key] = label;
        this.index[key] = i;
        this.raw = data;
    }
}

LabeledArray.prototype = new Array; // jshint ignore:line

module.constant("LabeledArray", LabeledArray);
